import styled from 'styled-components'

export const PageWrap = styled.div`
    margin: -1rem;
    min-height: calc(100vh - 55px);
    background: #f5f6f8;
    padding-bottom: 24px;
`

export const PageHeaderRow = styled.div`
    padding: 22px 28px 0;
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;

    h1 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #1f2937;
    }

    .header-actions {
        margin-left: auto;
    }
`

export const TabBar = styled.div`
    display: flex;
    gap: 0;
    padding: 0 28px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;

    button {
        background: none;
        border: none;
        border-bottom: 2px solid transparent;
        padding: 14px 18px;
        font-size: 13.5px;
        font-weight: 500;
        color: #6b7280;
        cursor: pointer;
        margin-bottom: -1px;
        font-family: inherit;

        &:hover {
            color: #3853cc;
        }

        &.active {
            color: #3853cc;
            border-bottom-color: #3853cc;
            font-weight: 600;
        }
    }
`

export const TabContent = styled.div`
    padding: 20px 28px;
`

export const InfoBanner = styled.div`
    padding: 12px 16px;
    border-radius: 6px;
    font-size: 13px;
    margin-bottom: 14px;
    border-left: 3px solid #0891b2;
    background: #ecfeff;
    color: #155e75;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    line-height: 1.55;
`

export const WarnBanner = styled(InfoBanner)`
    border-left-color: #f59e0b;
    background: #fef3c7;
    color: #92400e;
`

export const MasterListsLayout = styled.div`
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 18px;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`

export const ListsSidebar = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
    align-self: start;
`

export const ListsSidebarHeader = styled.div`
    padding: 12px 14px;
    background: #fafbfc;
    border-bottom: 1px solid #e5e7eb;
    font-weight: 600;
    font-size: 13px;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 8px;
`

export const ListsSidebarBody = styled.div`
    padding: 8px;
    max-height: calc(100vh - 320px);
    overflow-y: auto;
`

export const ListRow = styled.button`
    width: 100%;
    text-align: left;
    padding: 10px 12px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: background 0.12s;
    margin-bottom: 2px;
    border: none;
    background: ${p => (p.$active ? '#e8ecfb' : 'transparent')};
    opacity: ${p => (p.$inactive ? 0.5 : 1)};
    font-family: inherit;

    &:hover {
        background: ${p => (p.$active ? '#e8ecfb' : '#fafbfc')};
    }

    .list-icon {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        background: ${p => (p.$active ? '#3853cc' : '#e8ecfb')};
        color: ${p => (p.$active ? '#fff' : '#3853cc')};
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 12px;
        flex-shrink: 0;
    }

    .name {
        flex: 1;
        font-weight: 500;
        font-size: 13px;
        color: ${p => (p.$active ? '#3853cc' : '#1f2937')};
    }

    .count {
        color: #6b7280;
        font-weight: 400;
        margin-left: 4px;
        font-size: 11px;
    }

    .key {
        font-family: ui-monospace, monospace;
        font-size: 10px;
        background: ${p => (p.$active ? 'rgba(56, 83, 204, 0.15)' : '#e5e7eb')};
        color: ${p => (p.$active ? '#3853cc' : '#4b5563')};
        padding: 2px 6px;
        border-radius: 3px;
        font-weight: 500;
    }
`

export const MainCard = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
    overflow: hidden;
`

export const MainCardHeader = styled.div`
    padding: 12px 16px;
    background: #fafbfc;
    border-bottom: 1px solid #e5e7eb;
    font-weight: 600;
    font-size: 14px;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 10px;

    .actions {
        margin-left: auto;
        display: flex;
        gap: 8px;
    }
`

export const MainCardBody = styled.div`
    padding: 16px;
`

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;

    .grow {
        flex: 1;
        font-size: 12.5px;
        color: #6b7280;
    }
`

export const MasterAnswersFieldGroup = styled.div`
    margin-bottom: 14px;

    &:last-child {
        margin-bottom: 0;
    }
`

export const MasterAnswersFieldLabel = styled.label`
    display: block;
    font-size: 12.5px;
    color: #4b5563;
    margin-bottom: 6px;
    font-weight: 500;
`

export const MasterAnswersTextInput = styled.input`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    font-size: 13.5px;
    font-family: inherit;
    color: #1f2937;
    background: #fff;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #3853cc;
        box-shadow: 0 0 0 3px rgba(56, 83, 204, 0.2);
    }

    &:disabled {
        background: #f9fafb;
        color: #6b7280;
        cursor: not-allowed;
    }
`

export const EmptyHint = styled.div`
    text-align: center;
    color: #6b7280;
    padding: 36px 24px;
    font-size: 13px;

    .empty-icon {
        font-size: 32px;
        margin-bottom: 8px;
    }
`

export const PlaceholderPanel = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 32px 24px;
    text-align: center;
    color: #6b7280;
    font-size: 14px;
`

export const NewBadge = styled.span`
    background: #3853cc;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.05em;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    vertical-align: middle;
`

export const TemplateQuestionCard = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
`

export const TqHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid #eef0f3;
`

export const TqTypeBadge = styled.span`
    font-size: 10.5px;
    background: #e8ecfb;
    color: #3853cc;
    padding: 4px 9px;
    border-radius: 999px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
`

export const TqName = styled.span`
    flex: 1;
    font-weight: 600;
    font-size: 15px;
    color: #1f2937;
`

export const SettingsCard = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-bottom: 14px;
    overflow: hidden;
`

export const SettingsCardHeader = styled.div`
    padding: 10px 14px;
    font-size: 13px;
    font-weight: 600;
    border-bottom: 1px solid #e5e7eb;
    background: #fafbfc;
`

export const SettingsCardBody = styled.div`
    padding: 12px 14px;
    display: flex;
    gap: 18px;
    align-items: center;
    flex-wrap: wrap;
`

export const SourceToggle = styled.div`
    background: ${p => (p.$active ? '#e8ecfb' : '#fafbfc')};
    border: 1px solid ${p => (p.$active ? '#3853cc' : '#e5e7eb')};
    border-radius: 6px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 14px;
`

export const ToggleSwitch = styled.label`
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    flex-shrink: 0;
    cursor: pointer;

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        inset: 0;
        background: #cbd5e1;
        border-radius: 24px;
        transition: 0.2s;

        &::before {
            content: '';
            position: absolute;
            height: 16px;
            width: 16px;
            left: 3px;
            top: 3px;
            background: white;
            border-radius: 50%;
            transition: 0.2s;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
        }
    }

    input:checked + .slider {
        background: #10b981;

        &::before {
            transform: translateX(18px);
        }
    }
`

export const PreviewCard = styled.div`
    background: #fafbfc;
    border: 1px dashed #cbd5e1;
    border-radius: 6px;
    padding: 12px 14px;
    margin-top: 8px;
`

export const PreviewTitle = styled.div`
    font-size: 10.5px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 10px;
    font-weight: 700;
`

export const PreviewItem = styled.div`
    padding: 8px 12px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    margin: 5px 0;
    font-size: 13px;
    display: flex;
    gap: 10px;
    align-items: center;

    .score {
        font-size: 11px;
        color: #6b7280;
        margin-left: auto;
        background: #fafbfc;
        padding: 2px 8px;
        border-radius: 4px;
    }
`

export const WizardStepper = styled.div`
    display: flex;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 18px 24px;
    margin-bottom: 18px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
    position: relative;
`

const wizardStepTextColor = p => {
    if (p.$active) return '#3853cc'
    if (p.$done) return '#10b981'
    return '#6b7280'
}

const wizardStepFontWeight = p => (p.$active ? 600 : 500)

const wizardStepNumBackground = p => {
    if (p.$active) return '#3853cc'
    if (p.$done) return '#10b981'
    return '#e5e7eb'
}

const wizardStepNumColor = p => {
    if (p.$active || p.$done) return '#fff'
    return '#6b7280'
}

const wizardStepNumShadow = p => {
    if (p.$active) return '0 0 0 4px #e8ecfb'
    return 'none'
}

export const WizardStep = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 13px;
    color: ${wizardStepTextColor};
    font-weight: ${wizardStepFontWeight};
    position: relative;
    z-index: 1;

    .num {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: ${wizardStepNumBackground};
        color: ${wizardStepNumColor};
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 13px;
        flex-shrink: 0;
        box-shadow: ${wizardStepNumShadow};
    }
`

export const WizardStepperCompact = styled(WizardStepper)`
    padding: 10px 14px;
    margin-bottom: 12px;

    ${WizardStep} {
        font-size: 12px;
        gap: 8px;

        .num {
            width: 26px;
            height: 26px;
            font-size: 12px;
        }
    }
`

export const WizardCard = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-bottom: 16px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
`

export const WizardCardHeader = styled.div`
    padding: 14px 18px;
    border-bottom: 1px solid #e5e7eb;
    font-weight: 600;
    font-size: 14px;
`

export const WizardCardBody = styled.div`
    padding: 18px;
`

export const WizardCardBodyCompact = styled(WizardCardBody)`
    padding: 12px 14px;
`

export const WizardCardHeaderCompact = styled(WizardCardHeader)`
    padding: 10px 14px;
    font-size: 13px;
`

export const WizardNav = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: ${p => (p.$compact ? '12px' : '18px')};
    padding: ${p => (p.$compact ? '10px 14px' : '14px 18px')};
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    position: sticky;
    bottom: 16px;
    z-index: 20;
    box-shadow: 0 -6px 14px rgba(15, 23, 42, 0.06);

    .step-indicator {
        margin-right: auto;
        font-size: ${p => (p.$compact ? '12px' : '12.5px')};
        color: #6b7280;
    }
`

export const HintBox = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background: #f1f5f9;
    border: 1px dashed #94a3b8;
    border-radius: 6px;
    margin-bottom: 14px;
    font-size: 12.5px;
    color: #475569;
`

export const TemplateCardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 14px;
`

export const TemplatePickCard = styled.button`
    text-align: left;
    border: 2px solid ${p => (p.$checked ? '#3853cc' : '#e5e7eb')};
    border-radius: 6px;
    padding: 16px;
    background: ${p => (p.$checked ? '#e8ecfb' : '#fff')};
    cursor: pointer;
    font-family: inherit;
    position: relative;
    transition: all 0.15s;

    &:hover {
        border-color: #a5b4fc;
        box-shadow: 0 4px 6px rgba(15, 23, 42, 0.08);
    }

    .check {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 2px solid ${p => (p.$checked ? '#3853cc' : '#e5e7eb')};
        background: ${p => (p.$checked ? '#3853cc' : '#fff')};
        color: ${p => (p.$checked ? '#fff' : 'transparent')};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 700;
    }
`

export const MergeBuilder = styled.div`
    display: grid;
    grid-template-columns: 1fr 380px;
    gap: 18px;
    align-items: start;

    @media (max-width: 960px) {
        grid-template-columns: 1fr;
    }
`

export const MergeSourceRow = styled.div`
    border: 1px solid ${p => (p.$added ? '#10b981' : '#e5e7eb')};
    border-radius: 6px;
    padding: 12px 14px;
    margin-bottom: 8px;
    background: ${p => (p.$added ? '#ecfdf5' : '#fff')};
`

export const ItemChip = styled.span`
    display: inline-block;
    background: #f1f5f9;
    color: #4b5563;
    padding: 3px 9px;
    border-radius: 999px;
    margin: 3px 5px 3px 0;
    font-size: 11.5px;
    font-weight: 500;
`

export const MergeTargetPanel = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
    position: sticky;
    top: 90px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
`

export const MergeTargetHead = styled.div`
    background: linear-gradient(135deg, #3853cc, #2c44b0);
    color: #fff;
    padding: 16px 18px;

    h4 {
        margin: 0 0 4px;
        font-size: 14px;
    }

    p {
        margin: 0;
        font-size: 12px;
        opacity: 0.85;
    }
`

export const DoneCard = styled.div`
    text-align: center;
    padding: 20px 16px;
    background: #fff;
    border: 1px solid #10b981;
    border-radius: 6px;
    margin-bottom: 10px;

    .check-mark {
        width: 40px;
        height: 40px;
        margin: 0 auto 10px;
        border-radius: 50%;
        background: #10b981;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
    }

    h3 {
        margin: 0 0 4px;
        font-size: 15px;
        font-weight: 600;
        color: #1f2937;
    }

    p {
        margin: 0;
        color: #6b7280;
        font-size: 12.5px;
        line-height: 1.5;
    }

    .subtext {
        display: block;
        margin-top: 6px;
        font-size: 11.5px;
        color: #9ca3af;
    }
`

export const PostCommitNote = styled(InfoBanner)`
    padding: 8px 12px;
    font-size: 12px;
    margin-bottom: 0;
    line-height: 1.45;
`

export const Step4Summary = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px 12px;
    background: linear-gradient(135deg, #e8ecfb, #fff);
    border: 1px solid #3853cc;
    border-radius: 6px;
    margin-bottom: 10px;
`

export const Step4SummaryIcon = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #3853cc;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
`

export const Step4SummaryMain = styled.div`
    flex: 1;
    min-width: 0;

    h4 {
        margin: 0 0 2px;
        font-size: 14px;
        font-weight: 600;
        color: #1f2937;
    }

    .meta {
        font-size: 11px;
        color: #6b7280;
    }
`

export const Step4SummaryCount = styled.div`
    text-align: right;
    flex-shrink: 0;

    .num {
        font-size: 18px;
        font-weight: 700;
        color: #3853cc;
        line-height: 1;
    }

    .label {
        font-size: 10px;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        margin-top: 2px;
    }
`

export const Step4StatGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-bottom: 10px;
`

export const Step4StatCard = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 8px 10px;
    background: #fff;

    .label {
        font-size: 10px;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        font-weight: 600;
        margin-bottom: 2px;
    }

    .value {
        font-size: 20px;
        font-weight: 700;
        color: #3853cc;
        line-height: 1.1;
    }

    .suffix {
        font-size: 11px;
        color: #6b7280;
    }
`

export const Step4SafetyNote = styled.div`
    background: #ecfdf5;
    border-left: 3px solid #10b981;
    padding: 8px 10px;
    border-radius: 4px;
    color: #065f46;
    font-size: 11.5px;
    line-height: 1.45;
    margin-bottom: 10px;
`

export const Step4ItemsBox = styled.details`
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 8px 10px;
    background: #fff;
    font-size: 12px;

    summary {
        font-weight: 600;
        cursor: pointer;
        font-size: 12px;
        color: #1f2937;
    }

    .chips {
        margin-top: 8px;
    }
`

export const HistoryPanel = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-bottom: 18px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
`

export const HistoryRow = styled.div`
    padding: 12px 16px;
    border-bottom: 1px solid #eef0f3;
    display: flex;
    align-items: center;
    gap: 12px;
    opacity: ${p => (p.$rolledBack ? 0.55 : 1)};
    background: ${p => (p.$rolledBack ? '#fafbfc' : '#fff')};
`

export const ConflictRow = styled.div`
    padding: 12px 14px;
    border: 1px solid ${p => (p.$resolved ? '#10b981' : '#f59e0b')};
    background: ${p => (p.$resolved ? '#ecfdf5' : '#fffbeb')};
    border-radius: 6px;
    margin-bottom: 8px;
`
